import { observer } from "mobx-react";
import { Grid } from "@mui/material";

function FormRow({ children, width = "100%" }) {
    return (
        <Grid container spacing={2} sx={{ width }}>
            {children}
        </Grid>
    );
}

export default observer(FormRow);
